'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DotsIcon = function () {
  function DotsIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M10 10.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666zM10 5a.833.833 0 1 0 0-1.667A.833.833 0 0 0 10 5zM10 16.667A.833.833 0 1 0 10 15a.833.833 0 0 0 0 1.667z',
        fill: '#A8A4B9',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return DotsIcon;
}();

DotsIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var OnlinepbxModalDots = function (_React$Component) {
  _inherits(OnlinepbxModalDots, _React$Component);

  function OnlinepbxModalDots(props) {
    _classCallCheck(this, OnlinepbxModalDots);

    var _this = _possibleConstructorReturn(this, (OnlinepbxModalDots.__proto__ || Object.getPrototypeOf(OnlinepbxModalDots)).call(this, props));

    _this.state = {
      isModal: false,
      isRight: false,
      position: null
    };
    _this.isCursor = false;
    _this.domNode = document.createElement('div');
    _this.renderModal = _this.renderModal.bind(_this);
    _this.handleUpdate = _this.handleUpdate.bind(_this);
    return _this;
  }

  _createClass(OnlinepbxModalDots, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        this.handleUpdate();
        var containers = document.querySelectorAll('.scrollbar__dark');
        containers.forEach(function (container) {
          return container.addEventListener('scroll', _this2.handleUpdate);
        });
        document.body.appendChild(this.domNode);
        var windowSize = window.innerWidth;
        var container = this.modal && this.modal.getBoundingClientRect();
        var betweenRightAndQuestion = windowSize - container.x;
        if (betweenRightAndQuestion < (this.props.right || 215)) {
          this.setState({ isRight: true });
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        var _this3 = this;

        var containers = document.querySelectorAll('.scrollbar__dark');
        containers.forEach(function (container) {
          return container.removeEventListener('scroll', _this3.handleUpdate);
        });
        document.body.removeChild(this.domNode);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        if (this.state.isModal && this.state.isModal !== prevState.isModal) {
          this.modal.parentElement.style.visibility = 'visible';
          this.modal.parentElement.style.opacity = '1';
        } else if (this.state.isModal !== prevState.isModal) {
          this.modal.parentElement.style.visibility = '';
          this.modal.parentElement.style.opacity = '';
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'handleUpdate',
    value: function () {
      function handleUpdate() {
        this.setState({
          isModal: false,
          position: this.modal && this.modal.getBoundingClientRect()
        });
      }

      return handleUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var _onClick = this.props.onClick;

        return [_react2['default'].createElement(
          'div',
          {
            key: 'dots_wrapper',
            ref: function () {
              function ref(node) {
                if (node && !_this4.modal) {
                  _this4.forceUpdate();
                }
                _this4.modal = node || _this4.modal;
              }

              return ref;
            }(),
            onMouseEnter: function () {
              function onMouseEnter() {
                _this4.isCursor = false;
              }

              return onMouseEnter;
            }(),
            onMouseLeave: function () {
              function onMouseLeave() {
                _this4.isCursor = true;
              }

              return onMouseLeave;
            }(),
            className: 'onlinepbx__lib__modal__dots'
          },
          _react2['default'].createElement(
            'button',
            {
              onClick: function () {
                function onClick(evt) {
                  typeof _onClick === 'function' && _onClick(evt);
                  _this4.handleUpdate();
                  _this4.setState({ isModal: !_this4.state.isModal });
                }

                return onClick;
              }(),
              className: 'onlinepbx__lib__modal__dots__button'
            },
            _react2['default'].createElement(DotsIcon, { className: 'onlinepbx__lib__modal__dots__icon' })
          )
        ), this.state.isModal && _reactDom2['default'].createPortal(this.renderModal(), this.domNode)];
      }

      return render;
    }()
  }, {
    key: 'renderModal',
    value: function () {
      function renderModal() {
        var _this5 = this;

        var _props$buttons = this.props.buttons,
            buttons = _props$buttons === undefined ? [] : _props$buttons;

        return _react2['default'].createElement(
          'div',
          {
            tabIndex: 0,
            onMouseEnter: function () {
              function onMouseEnter() {
                _this5.isCursor = false;
              }

              return onMouseEnter;
            }(),
            onMouseLeave: function () {
              function onMouseLeave() {
                _this5.isCursor = true;
              }

              return onMouseLeave;
            }(),
            style: _extends({
              top: this.state.position && this.state.position.y >= document.body.clientHeight / 2.4 ? 'auto' : this.state.position.top + 27
            }, this.state.isRight ? { right: 15 } : { left: this.state.position.x }, {
              bottom: this.state.position && this.state.position.y >= document.body.clientHeight / 2.4 ? document.body.clientHeight - this.state.position.bottom + 27 : 'auto'
            }),
            ref: function () {
              function ref(node) {
                return node && node.focus();
              }

              return ref;
            }(),
            onBlur: function () {
              function onBlur() {
                return _this5.isCursor && _this5.setState({ isModal: false });
              }

              return onBlur;
            }(),
            className: 'onlinepbx__lib__modal__dots__modal'
          },
          buttons.map(function (_ref, index) {
            var buttonName = _ref.buttonName,
                _onClick2 = _ref.onClick,
                line = _ref.line,
                link = _ref.link,
                download = _ref.download;
            return [line && _react2['default'].createElement('div', { className: 'onlinepbx__lib__modal__dots__modal__line' }), link ? _react2['default'].createElement(
              'a',
              {
                download: download || 'rec.mp3',
                rel: 'noreferrer noopener',
                target: '_blank',
                className: 'onlinepbx__lib__modal__dots__modal__option',
                key: index.toString(),
                onClick: function () {
                  function onClick(evt) {
                    typeof _onClick2 === 'function' && _onClick2(evt);
                    _this5.setState({ isModal: false });
                  }

                  return onClick;
                }(),
                href: link
              },
              buttonName
            ) : _react2['default'].createElement(
              'button',
              {
                key: index.toString(),
                className: 'onlinepbx__lib__modal__dots__modal__option',
                onClick: function () {
                  function onClick(evt) {
                    typeof _onClick2 === 'function' && _onClick2(evt);
                    _this5.setState({ isModal: false });
                  }

                  return onClick;
                }()
              },
              buttonName
            )];
          })
        );
      }

      return renderModal;
    }()
  }]);

  return OnlinepbxModalDots;
}(_react2['default'].Component);

exports['default'] = OnlinepbxModalDots;